import React, { useState } from 'react';
import Modal from '../../../../components/common/Modal';
import Button from '../../../../components/common/Button';
import Select from '../../../../components/common/Select';
import { supabase } from '../../../../supabase';
import styles from './JoinTeamModal.module.css';

function JoinTeamModal({ isOpen, onClose, ideaId, onSuccess }) {
  const [role, setRole] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const roleOptions = [
    { value: '', label: '역할을 선택해주세요' },
    { value: 'developer', label: '개발자' },
    { value: 'designer', label: '디자이너' },
    { value: 'planner', label: '기획자' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        alert('로그인이 필요합니다.');
        return;
      }

      const { error } = await supabase
        .from('idea_members')
        .insert({
          idea_id: ideaId,
          user_id: user.id,
          role: role,
          status: 'pending'
        });

      if (error) throw error;

      alert('팀 참여 신청이 완료되었습니다.');
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error('Error submitting join request:', error);
      alert('신청 중 오류가 발생했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="팀 참여 신청" type="bottom-sheet">
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <label htmlFor="role">희망 역할</label>
          <Select
            id="role"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
            options={roleOptions}
          />
        </div>

        <div className={styles.buttons}>
          <Button
            type="submit"
            color="primary"
            width="full-width"
            disabled={isSubmitting}
          >
            {isSubmitting ? '신청 중...' : '참여 신청하기'}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export default JoinTeamModal; 